import type {JSX} from 'react';

import {
  TransactionDetailTable,
  TransactionDetailTableHeader,
} from '@/components/transactions/Detail';
import type {AfriexAdminTransaction} from '@/types';

type TransactionSummaryProp = {
  data: AfriexAdminTransaction;
};

export default function TransactionSummary({
  data,
}: TransactionSummaryProp): JSX.Element {
  return (
    <div className="bg-white dark:bg-gray-900 rounded-lg w-full px-5 sm:px-10 py-5 sm:py-10">
      <TransactionDetailTableHeader data={data} />
      <TransactionDetailTable data={data} />
    </div>
  );
}
